import { combineReducers } from 'redux';
import userDetails from './userDetails';

export const reducers = combineReducers({
  userDetails
});
